import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { HTTPError } from 'ky';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';
import { LabelQueryKeys } from '~settings/api/config/queryKeys';
import { BFFClient } from '~settings/api/lib/BFFClient';
import { getRequestHeaders } from '~settings/api/lib/headers';
import type { PresetUseMutationOptions } from '~settings/api/lib/types';

interface DeleteLabelVariables {
  id: string;
  name: string;
}

export const useLabelDelete = (
  options?: PresetUseMutationOptions<unknown, DeleteLabelVariables>,
) => {
  const { token } = useWmgSession();
  const queryClient = useQueryClient();

  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation<unknown, HTTPError, DeleteLabelVariables>({
    mutationFn: async (variables) => {
      return BFFClient.delete(`labels/${variables.id}`, {
        headers: getRequestHeaders(token),
      }).json();
    },

    onSuccess: async (data, variables, ctx) => {
      if (onSuccess) {
        onSuccess(data, variables, ctx);
      }

      queryClient.removeQueries({
        queryKey: LabelQueryKeys.detail({ labelId: variables.id }),
      });

      await queryClient.invalidateQueries({
        queryKey: LabelQueryKeys.list({}),
      });
    },
    onError: (error) => {
      console.error('Label delete failed:', error);
    },
    ...restOptions,
  });
};
